export default "__VITE_ASSET__Bi56zNt8__"